import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.75 5.756a4.5 4.5 0 1 0 0 8.488M6 8.5h5.25M6 11.5h5.25M19.5 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  stroke: "#02504B",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }